<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Costituzione" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Peso(Kg):</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.peso }}</span>
                            <b-form-input v-else v-model="jsonDataCostituzione.peso" :readonly="isReadOnly" type="number" step="0.01"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Altezza(cm):</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.altezza }}</span>
                            <b-form-input v-else v-model="jsonDataCostituzione.altezza" :readonly="isReadOnly" type="number" step="0.01"> </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Tipologia:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.tipologia }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.tipologia" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Condizioni di nutr. e Sang.:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.condizioniNutrSangue }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.condizioniNutrSangue" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Cute e mucoso visibili:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.cuteMucoseVisibili }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.cuteMucoseVisibili" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Linfoghiandole:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.linfoghiandole }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.linfoghiandole" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Capo:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.capo }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.capo" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Dentatura:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.dentatura }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.dentatura" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Pannicolo Adiposo:</label>
                            <span v-if="isReadOnly">{{ jsonDataCostituzione.pannicoloAdiposo }}</span>
                            <b-form-textarea v-else v-model="jsonDataCostituzione.pannicoloAdiposo" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataCostituzione: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    peso: "",
                    altezza: "",
                    tipologia: "",
                    condizioniNutrSangue: "",
                    cuteMucoseVisibili: "",
                    linfoghiandole: "",
                    capo: "",
                    dentatura: "",
                    pannicoloAdiposo: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataCostituzione: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaCostituzione: "/rsaschedarelazionesanitariacostituzione",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaCostituzione() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaCostituzione + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaCostituzioneSuccess, me.resultResponseSchedaRelazioneSanitariaCostituzioneError);
        },

        resultResponseSchedaRelazioneSanitariaCostituzioneSuccess(response) {
            let me = this;
            me.jsonDataCostituzione = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaCostituzioneError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataCostituzione = {
                id: null,
                idAccettazione: this.idAccettazione,
                peso: "",
                altezza: "",
                tipologia: "",
                condizioniNutrSangue: "",
                cuteMucoseVisibili: "",
                linfoghiandole: "",
                capo: "",
                dentatura: "",
                pannicoloAdiposo: "",
            };
        },

        onSalvaCostituzione() {
            let me = this;
            me.jsonDataCostituzione.idAccettazione = me.idAccettazione;
            if (!me.jsonDataCostituzione.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaCostituzione, me.jsonDataCostituzione, me.saveSchedaRelazioneSanitariaCostituzioneSuccessResponse, me.saveSchedaRelazioneSanitariaCostituzioneErrorResponse);
        },
        saveSchedaRelazioneSanitariaCostituzioneSuccessResponse() {},
        saveSchedaRelazioneSanitariaCostituzioneErrorResponse() {
            console.error("Errore nel salvataggio della costituzione:");
        },
    },
};
</script>
